module.exports = __webpack_public_path__ + "img/profile_small.7ab3adc6.jpg";